module.exports = __webpack_public_path__ + "img/sos-type-pink.d467e5b7.png";